"use client"

import type { Address } from "@opensea/utils"
import { isAddressEqual } from "@opensea/utils"
import { createContext, useContext, useEffect } from "react"
import { create } from "zustand"
import { useAddress } from "@/hooks/wallet"

// Using zustand to so that it can be accessed by the top nav
const useProfileAddressStore = create<{
  address: Address | undefined
  setAddress: (address: Address | undefined) => void
}>(set => ({
  address: undefined,
  setAddress: (address: Address | undefined) => set({ address }),
}))

const ProfileAddressContext = createContext<Address>("")

type Props = {
  address: Address
  children: React.ReactNode
}

export function ProfileAddressProvider({ address, children }: Props) {
  const setAddress = useProfileAddressStore(state => state.setAddress)
  useEffect(() => {
    setAddress(address)
    return () => {
      setAddress(undefined)
    }
  }, [address, setAddress])
  return (
    <ProfileAddressContext.Provider value={address}>
      {children}
    </ProfileAddressContext.Provider>
  )
}

export const useProfileAddress = () => useContext(ProfileAddressContext)

export const useIsOwnProfileAddress = () => {
  const addressStoreAddress = useProfileAddressStore(state => state.address)
  const address = useProfileAddress() || addressStoreAddress
  const ownAddress = useAddress()
  return isAddressEqual(address, ownAddress)
}
